import get from './get'
import getMe from './getMe'
import getNowOptions from './getNowOptions'
import set from './set'
import setNowOptions from './setNowOptions'
import update from './update'
import create from './create'

export default {
  ...get,
  ...getMe,
  ...getNowOptions,
  ...set,
  ...setNowOptions,
  ...update,
  ...create
}
